"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sleep = sleep;
function sleep(waitMs, abortSignal) {
    if (waitMs <= 0 || abortSignal?.aborted) {
        return Promise.resolve();
    }
    return new Promise((resolve) => {
        abortSignal?.addEventListener('abort', onAbort);
        const timeout = setTimeout(() => {
            resolve();
            abortSignal?.removeEventListener('abort', onAbort);
        }, waitMs);
        function onAbort() {
            clearTimeout(timeout);
            resolve();
        }
    });
}
//# sourceMappingURL=Sleep.js.map